import { List } from '@hai/ui-react';
import React from 'react';
import { SortDirection, SortManager } from 'src/js/component/sort-manager';
import { constant } from 'src/js/util/constant';
import { EssenceViewModel } from './essence-models';
import { EssenceRow } from './essence-row';

interface EssenceProps {
  list: EssenceViewModel[];
  direction: SortDirection;
  onSelect: (model: EssenceViewModel, selected: boolean) => void;
  sorting: string;
  sortInfo: any;
  nmosServiceActive: boolean;
}

export const EssenceList: React.FunctionComponent<EssenceProps> = ({
  list,
  direction,
  onSelect,
  sorting,
  sortInfo,
}) => {
  return (
    <List accentColor={constant.productColor}>
      <SortManager sortInfo={sortInfo} list={list} sortKey={sorting} direction={direction} secondLevelSortKey="name">
        {list &&
          list.map((model: EssenceViewModel) => {
            return <EssenceRow key={model.id} model={model} onSelect={onSelect} />;
          })}
      </SortManager>
    </List>
  );
};
